import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Megaphone } from "lucide-react";

export const BroadcastModal = ({ open, onClose, title, message }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
    <DialogContent className="sm:max-w-md" data-testid="broadcast-modal">
      <DialogHeader className="text-center">
        <div className="flex justify-center mb-3">
          <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
            <Megaphone className="w-8 h-8 text-[#F97316]" />
          </div>
        </div>
        <DialogTitle className="text-xl text-center" data-testid="broadcast-modal-title">{title || "Clueer"}</DialogTitle>
        <DialogDescription className="text-center text-base text-[#374151]" data-testid="broadcast-modal-message">
          {message}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button
          onClick={onClose}
          className="w-full rounded-full bg-[#F97316] hover:bg-[#EA580C] h-11"
          data-testid="broadcast-modal-close"
        >
          Entendido
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default BroadcastModal;
